import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '@/environments/environment';
import { Base64 } from 'js-base64';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CombustiblesService {

  private endpoint: string | null;

  constructor(
    private httpClient: HttpClient
  ) {
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/catalogos/Combustibles';
   }

  obtenerCombustibles(){
    return this.httpClient.get(this.endpoint + '/GetCombustibles');
  }
  crearCombustibles(CombustibleRQ: any) {
    return this.httpClient.post(this.endpoint + '/InsertCombustibles', CombustibleRQ);
  }
  editarCombustible(CombustibleRQ: any) {
    return this.httpClient.post(this.endpoint + '/UpdateCombustibles', CombustibleRQ);
  }

  obtenerCombustiblesCatalog() {
    return this.obtenerCombustibles().pipe(
      map((data: any) => {
        if (data?.Combustible) {
          return data.Combustible
            .filter((i: any) => i['tipo'] !== '')
            .map((i: any) => ({ label: i.tipo, value: i.tipo }));
        }
        return [];
      })
    );
  }
}
